export function LogoMark({ className = "h-9 w-9" }) {
  return (
    <svg viewBox="0 0 64 64" className={className} role="img" aria-label="SportsGearDFW logo" data-testid="sgdfw-logo">
      <defs>
        <linearGradient id="sgdfw-bg" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#38BDF8" />
          <stop offset="1" stopColor="#0369A1" />
        </linearGradient>
      </defs>
      <rect width="64" height="64" rx="14" fill="url(#sgdfw-bg)" />
      <g fill="#082F49">
        <rect x="10" y="40" width="7" height="16" rx="1" />
        <rect x="19" y="34" width="7" height="22" rx="1" />
        <rect x="38" y="37" width="7" height="19" rx="1" />
        <rect x="47" y="42" width="7" height="14" rx="1" />
        <rect x="29.5" y="26" width="3" height="30" />
      </g>
      <circle cx="31" cy="22" r="6.5" fill="#F8FAFC" />
      <path d="M47 12 L48.8 15.9 L53.1 16.5 L50.1 19.4 L50.8 23.7 L47 21.7 L43.2 23.7 L43.9 19.4 L40.9 16.5 L45.2 15.9 Z" fill="#F8FAFC" />
    </svg>
  );
}

export default LogoMark;

import { useEffect, useState } from "react";
import api, { fileUrl } from "@/lib/api";

let brandingPromise = null;
function loadBranding() {
  if (!brandingPromise) {
    brandingPromise = api.get("/branding").then(({ data }) => data || {}).catch(() => ({}));
  }
  return brandingPromise;
}

export function useSiteLogo() {
  const [logoUrl, setLogoUrl] = useState(null);
  useEffect(() => {
    let live = true;
    loadBranding().then((data) => {
      if (!live) return;
      const url = data?.logo_url || null;
      setLogoUrl(url);
      if (url) {
        let link = document.querySelector('link[rel="icon"]');
        if (!link) {
          link = document.createElement("link");
          link.rel = "icon";
          document.head.appendChild(link);
        }
        link.href = fileUrl(url);
      }
    });
    return () => { live = false; };
  }, []);
  return logoUrl;
}

export function useSocials() {
  const [socials, setSocials] = useState({});
  useEffect(() => {
    let live = true;
    loadBranding().then((data) => { if (live) setSocials(data?.socials || {}); });
    return () => { live = false; };
  }, []);
  return socials;
}

export function SiteLogo({ className = "h-9 w-9" }) {
  const logoUrl = useSiteLogo();
  if (logoUrl) {
    return <img src={fileUrl(logoUrl)} alt="SportsGearDFW logo" data-testid="sgdfw-logo" className={`object-contain ${className}`} />;
  }
  return <LogoMark className={className} />;
}

